import { yatzy } from './Yatzy.mjs';
import ShakeDetector from 'shake-detector';
yatzy.init();

// Shake to roll dice 

( new ShakeDetector() ).start();
window.addEventListener(
	ShakeDetector.SHAKE_EVENT,
	function(){yatzy.rollDice();}
);

// Click link to roll dice

window.onload = function () {
	document.getElementById("reroll").addEventListener( "click",
		function(){ yatzy.rollDice(); }
	);
	document.getElementById("reroll_all").addEventListener( "click",
		function(){
			yatzy.unlockDice();
			yatzy.rollDice();
		}
	);
}
